import { styled } from '@mui/material';

import { inputBaseClasses } from '../../../../../../components/FormControls/TextFieldBase/styles';
import TextField from '../../../../../../components/HookFormControls/TextField';
import { hexToRgba } from '../../../../../../utils/color';

export const Root = styled('div')(({ theme }) => ({
  padding: theme.spacing(0.5, 2),
  borderRadius: 4,
  color: theme.palette.common.black,
  backgroundColor: hexToRgba(theme.palette.primary.main, 0.05),
}));

export const DigitField = styled(TextField)(({ theme }) => ({
  [`& .${inputBaseClasses.root}`]: {
    backgroundColor: 'transparent',
    border: 'none',
    // increase specificity
    [`& .${inputBaseClasses.input}.${inputBaseClasses.input}`]: {
      fontSize: theme.typography.pxToRem(64),
      fontFamily: theme.typography.displayBold.fontFamily,
      padding: 0,
      textAlign: 'center',
      height: 'unset',
      width: theme.spacing(10),
      '&::-webkit-textfield-decoration-container': {
        display: 'none',
        webkitAppearance: 'none',
        mozAppearance: 'textfield',
      },
    },
  },
})) as typeof TextField;
